"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultType = exports.autoHideDuration = exports.errorType = exports.warningType = exports.errorRole = exports.typeToClass = exports.classes = void 0;
var classes = {
  container: 'bds-notification-container',
  notification: 'bds-notification',
  image: 'bds-notification-image',
  title: 'bds-notification-title',
  closeButton: 'bds-notification-close-button',
  icon: 'bds-notification-icon',
  errorIconColor: 'bds-notification-error-icon-color',
  warningIconColor: 'bds-notification-warning-icon-color',
  inPlaceNotification: 'bds-notification-container-in-place'
};
exports.classes = classes;
var typeToClass = {
  success: 'bds-notification-success',
  error: 'bds-notification-error',
  general: 'bds-notification-general',
  warning: 'bds-notification-warning'
};
exports.typeToClass = typeToClass;
var errorRole = 'errorItem';
exports.errorRole = errorRole;
var warningType = 'warning';
exports.warningType = warningType;
var errorType = 'error';
exports.errorType = errorType;
var autoHideDuration = 5000;
exports.autoHideDuration = autoHideDuration;
var defaultType = 'general';
exports.defaultType = defaultType;